import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Navbar from "../components/Navbar";
import ErrorPage from "../components/ErrorPage";
import Loader from "../components/Loader";
import TableToolbar from "../components/TableToolbar";
import {toast} from "react-toastify";
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
} from "@chakra-ui/react";

function DeleteHistory() {
    const [exams, setExams] = useState([]);
    const [examId, setExamId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [foundUser, setFoundUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searching, setSearching] = useState(false);
    const [error, setError] = useState(null);
    const {isOpen, onOpen, onClose} = useDisclosure();

    useEffect(() => {
        const fetchExams = async () => {
            setLoading(true);
            try {
                const response = await api.get("/api/exam/list/all");
                setExams(response.data.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchExams();
    }, []);

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!examId || !phoneNumber) {
            toast.error("آزمون و شماره همراه را وارد کنید!", {
                position: "bottom-right",
            });
            return;
        }
        setFoundUser(null);
        setSearching(true);
        try {
            const response = await api.post("/api/exam/history/lookup", {
                exam_id: examId,
                phone_number: phoneNumber,
            });
            setFoundUser(response.data.data);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message, {
                    position: "bottom-right",
                });
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right",
                });
            } else {
                toast.error("خطایی رخ داد!", {
                    position: "bottom-right",
                });
            }
        } finally {
            setSearching(false);
        }
    };

    const handleDelete = async () => {
        try {
            const response = await api.post("/api/exam/history/delete", {
                user_id: foundUser.user_id,
                exam_id: examId,
            });
            toast.success(response.data.message, {
                position: "bottom-right",
            });
            setFoundUser(null);
            setPhoneNumber("");
            onClose();
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message, {
                    position: "bottom-right",
                });
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right",
                });
            } else {
                toast.error("خطایی رخ داد!", {
                    position: "bottom-right",
                });
            }
        }
    };

    if (loading) return <Loader/>;
    if (error) return <ErrorPage error={error}/>;
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="admin-page flex-fill">
                <TableToolbar title="حذف سابقه آزمون"/>

                <div className="admin-table-card p-4">
                    <form onSubmit={handleSearch}>
                        <div className="custom-input-group mb-3">
                            <label>آزمون</label>
                            <select
                                className="form-control"
                                value={examId}
                                onChange={(e) => {
                                    setExamId(e.target.value);
                                    setFoundUser(null);
                                }}
                            >
                                <option value="">انتخاب آزمون</option>
                                {exams.map((exam) => (
                                    <option key={exam.id} value={exam.id}>
                                        {exam.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="custom-input-group mb-3">
                            <label>شماره همراه</label>
                            <input
                                type="text"
                                className="form-control"
                                value={phoneNumber}
                                onChange={(e) => {
                                    setPhoneNumber(e.target.value);
                                    setFoundUser(null);
                                }}
                                placeholder="شماره همراه کاربر"
                            />
                        </div>
                        <button type="submit" className="btn btn-outline-green" disabled={searching}>
                            {searching ? "در حال جستجو..." : "جستجو"}
                        </button>
                    </form>

                    {foundUser && (
                        <div className="mt-4 d-flex align-items-center gap-3 flex-wrap">
                            <span>کاربر یافت شده: <strong>{foundUser.name}</strong></span>
                            <button className="btn btn-outline-red" onClick={onOpen}>
                                حذف سابقه آزمون این کاربر
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>حذف سابقه آزمون</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <p>
                            آیا از حذف پاسخ‌ها و کارنامه {foundUser?.name} برای این آزمون اطمینان دارید؟ این عملیات
                            غیرقابل بازگشت است.
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="gray" mr={3} onClick={onClose} marginX={"1rem"}>
                            بستن
                        </Button>
                        <Button colorScheme="red" onClick={handleDelete}>
                            حذف
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </div>
    );
}

export default DeleteHistory;
